module.exports = __webpack_public_path__ + "static/img/point3.d58c803.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/point3.png
// module id = p71q
// module chunks = 36